import { backToParent } from '../../_utils/navTrail';
import React, { useState, useEffect } from 'react';
import { canCatalogue, can, isOwnerHere } from '../permissions/access';
import { withRouter } from 'react-router-dom';
import { readSitesCache } from '../multiLocation/useSites';
import { connect } from 'react-redux';
import axios from 'axios';
import config from '../../config/API';
import useWindowSize from './useWindowSize';
import NotificationBell from '../notifications/NotificationBell';
import LocationPicker from '../multiLocation/LocationPicker';
import './CatalogueTopNav.css';

// Icons
const ServicesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const ProductsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const VouchersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const TransfersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 7h13" />
    <path d="M13 3l4 4-4 4" />
    <path d="M20 17H7" />
    <path d="M11 13l-4 4 4 4" />
  </svg>
);

// Stock transfers only make sense with two or more locations on the account.
const hasMultipleSites = () => {
  const c = readSitesCache();
  return !!(c && c.sites && c.sites.length > 1);
};

const StockTakeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="M9 12h6" />
    <path d="M9 16h6" />
  </svg>
);

const ResourcesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M5 21V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14" />
    <path d="M14 21v-6a2 2 0 0 0-4 0v6" />
  </svg>
);

const FormsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);
const TaxesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="5" x2="5" y2="19" />
    <circle cx="6.5" cy="6.5" r="2.5" />
    <circle cx="17.5" cy="17.5" r="2.5" />
  </svg>
);


const ShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const BackArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

// Default settings - defined outside component to avoid recreation
const defaultSettings = {
  enabled: false,
  hiddenAreas: {
    diary: false,
    checkout: false,
    clients: false,
    transactions: false,
    catalogue: false,
    services: false,
    products: false,
    stocktake: false,
    staff: false,
    settings: false,
    marketing: false,
    giftcards: false,
    forms: false
  }
};

// Get initial settings from localStorage (called once during initialization)
const getInitialSettings = () => {
  try {
    const cached = localStorage.getItem('receptionModeSettings');
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (e) {
    // Ignore parse errors
  }
  return defaultSettings;
};

function CatalogueTopNav(props) {
  // Use lazy initialization to only read localStorage once
  const [receptionModeSettings, setReceptionModeSettings] = useState(getInitialSettings);

  useEffect(() => {
    // Fetch settings in background to keep them fresh
    checkReceptionModeSettings();

    // Listen for the custom event from ReceptionMode component
    window.addEventListener('receptionModeSettingsChanged', handleReceptionModeSettingsChanged);

    return () => {
      window.removeEventListener('receptionModeSettingsChanged', handleReceptionModeSettingsChanged);
    };
  }, []);

  const handleReceptionModeSettingsChanged = (event) => {
    if (event.detail) {
      const { enabled, hiddenAreas } = event.detail;

      if (enabled !== undefined) {
        const newSettings = {
          enabled,
          hiddenAreas: hiddenAreas || receptionModeSettings.hiddenAreas
        };

        setReceptionModeSettings(newSettings);
      }
    }
  };

  const checkReceptionModeSettings = () => {
    const { user } = props;
    if (!user || !user.userInfo || !user.userInfo.hairdresser) {
      return;
    }

    const hairdresserId = user.userInfo.hairdresser._id;
    let accessToken = localStorage.getItem('accessToken');

    axios.get(`${config.RECEPTION_MODE_SETTINGS}?hairdresserId=${hairdresserId}`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': accessToken
      }
    })
    .then(response => {
      if (response.data.statusCode === 1) {
        const { enabled, hiddenAreas } = response.data.responseData;
        const newSettings = {
          enabled,
          hiddenAreas: hiddenAreas || defaultSettings.hiddenAreas
        };
        setReceptionModeSettings(newSettings);
        // Cache the settings
        localStorage.setItem('receptionModeSettings', JSON.stringify(newSettings));
      }
    })
    .catch(error => {
      console.error('Error fetching reception mode settings:', error);
    });
  };

  const { width } = useWindowSize();
  const isMobile = width <= 1100;

  // Redux user state can be stale after redux-persist rehydrates an older
  // snapshot — the persisted blob may pre-date when isSalonOwner became
  // populated, so the tabs render as if the user is a stylist. localStorage
  // is rewritten on every login + profile-switch so it's the authoritative
  // value when Redux is empty. Falling back here keeps the catalogue tabs
  // accurate without requiring a profile-switch to "fix" the page.
  const localUser = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch (e) { return {}; }
  })();
  const isSalonOwner =
    props.user?.userInfo?.hairdresser?.isSalonOwner === 1
    || localUser?.hairdresser?.isSalonOwner === 1;
  const isSelfEmployed =
    props.user?.userInfo?.hairdresser?.employmentTypeId === 2
    || localUser?.hairdresser?.employmentTypeId === 2;
  const { enabled: receptionEnabled, hiddenAreas } = receptionModeSettings;

  // Build navigation items based on permissions and reception mode
  const navItems = [];

  // Services - always visible unless hidden
  if (!receptionEnabled || !hiddenAreas.services) {
    navItems.push({
      id: 'services',
      path: '/new-services',
      label: 'Services',
      icon: <ServicesIcon />
    });
  }

  // Products - salon owners only
  if (canCatalogue(isSalonOwner, 'products') && (!receptionEnabled || !hiddenAreas.products)) {
    navItems.push({
      id: 'products',
      path: '/product',
      label: 'Products',
      icon: <ProductsIcon />
    });
  }

  // Vouchers — the V2 gift-card module is now the one and only Vouchers tab
  // (the legacy /voucher page is retired; its route redirects here).
  if (canCatalogue(isSalonOwner, 'gift_cards') && (!receptionEnabled || !hiddenAreas.giftcards)) {
    navItems.push({
      id: 'vouchers-v2',
      path: '/voucher-v2',
      label: 'Vouchers',
      icon: <VouchersIcon />
    });
  }

  // Stock Take - salon owners only
  if (canCatalogue(isSalonOwner, 'products') && (!receptionEnabled || !hiddenAreas.stocktake)) {
    navItems.push({
      id: 'stocktake',
      path: '/stocktake',
      label: 'Stock Take',
      icon: <StockTakeIcon />
    });
  }

  // Stock transfers between locations - multi-location owners only
  if ((isSalonOwner || isOwnerHere()) && hasMultipleSites() && (!receptionEnabled || !hiddenAreas.stocktake)) {
    navItems.push({
      id: 'stock-transfers',
      path: '/stock-transfers',
      label: 'Transfers',
      icon: <TransfersIcon />
    });
  }

  // Resources (rooms/equipment) - salon owners only
  if ((isSalonOwner || can('settings')) && (!receptionEnabled || !hiddenAreas.resources)) {
    navItems.push({
      id: 'resources',
      path: '/resources',
      label: 'Resources',
      icon: <ResourcesIcon />
    });
  }

  // Forms - the owner, or a role with the catalogue
  if (canCatalogue(isSalonOwner, 'services') && (!receptionEnabled || !hiddenAreas.forms)) {
    navItems.push({
      id: 'forms',
      path: '/forms',
      label: 'Forms',
      icon: <FormsIcon />
    });
  }

  // Taxes - owners and self-employed each manage their own tax rates
  // (employed staff inherit the owner's; they never see tax config)
  const { TAXES_VISIBLE } = require('../../config/featureFlags');
  if (TAXES_VISIBLE && (isSalonOwner || isSelfEmployed || can('settings')) && (!receptionEnabled || !hiddenAreas.taxes)) {
    navItems.push({
      id: 'taxes',
      path: '/taxes',
      label: 'Taxes',
      icon: <TaxesIcon />
    });
  }

  // Check if current path matches any nav item
  const isActive = (path) => {
    const currentPath = props.location.pathname;
    if (path === '/new-services') {
      return currentPath === '/new-services' ||
             currentPath.startsWith('/add-services') ||
             currentPath.startsWith('/edit-services');
    }
    if (path === '/product') {
      return currentPath === '/product' ||
             currentPath.startsWith('/product/');
    }
    if (path === '/stocktake') {
      return currentPath === '/stocktake' ||
             currentPath.startsWith('/stocktake/');
    }
    if (path === '/forms') {
      return currentPath === '/forms' ||
             currentPath.startsWith('/forms/');
    }
    return currentPath === path || currentPath.startsWith(path + '/');
  };

  // Determine if we're on a sub-page (e.g. /add-services, /edit-services/:id, /forms/new, etc.)
  // Sub-pages should navigate back to their parent catalogue section, not /service-nav
  const getBackDestination = () => {
    const currentPath = props.location.pathname;

    // Services sub-pages → back to /new-services
    if (currentPath.startsWith('/add-services') || currentPath.startsWith('/edit-services')) {
      return '/new-services';
    }
    // Product sub-pages → back to /product
    if (currentPath.startsWith('/product/')) {
      return '/product';
    }
    // Stocktake sub-pages → back to /stocktake
    if (currentPath.startsWith('/stocktake/') || currentPath === '/stocktake/new') {
      return '/stocktake';
    }
    // Forms sub-pages → back to /forms
    if (currentPath.startsWith('/forms/')) {
      return '/forms';
    }

    // Top-level catalogue pages → back to catalogue menu
    return '/service-nav';
  };

  const isSubPage = () => {
    const currentPath = props.location.pathname;
    return (
      currentPath.startsWith('/add-services') ||
      currentPath.startsWith('/edit-services') ||
      currentPath.startsWith('/product/') ||
      currentPath.startsWith('/stocktake/') ||
      currentPath.startsWith('/forms/')
    );
  };

  // Get current page title for mobile header
  const getCurrentPageTitle = () => {
    // For sub-pages, show the parent section name
    const activeItem = navItems.find(item => isActive(item.path));
    return activeItem ? activeItem.label : 'Catalogue';
  };

  const handleBackClick = () => {
    backToParent(props.history, getBackDestination());
  };

  // Mobile: show header with back button and page title
  if (isMobile) {
    return (
      <div className="catalogue-mobile-header">
        <button className="catalogue-mobile-back-btn" onClick={handleBackClick}>
          <BackArrowIcon />
        </button>
        <h1 className="catalogue-mobile-title">{getCurrentPageTitle()}</h1>
        <div className="catalogue-mobile-actions">
          <LocationPicker slot="mobile" />
          {props.children}
        </div>
      </div>
    );
  }

  // Desktop: the overview (/catalogue) is the menu, so no tab strip. A page
  // gets a slim bar: back to Catalogue, the page title, its actions, the bell.
  const onOverview = props.location.pathname === '/catalogue';
  return (
    <div className={`catalogue-top-nav catalogue-topbar${onOverview ? ' catalogue-topbar--hub' : ''}`}>
      <div className="catalogue-top-nav-container">
        <div className="catalogue-top-nav-content">
          {!onOverview && (
            <>
              <button
                type="button"
                className="catalogue-tab-btn catalogue-tab-back"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => props.history.push('/catalogue')}
                aria-label="Catalogue"
              >
                <BackArrowIcon />
                <span>Catalogue</span>
              </button>
              <h2 className="catalogue-topbar-title">{getCurrentPageTitle()}</h2>
            </>
          )}
          <div className="catalogue-nav-actions">
            {props.children}
          </div>
        </div>
      </div>
      <div className="notif-bell-pinned-wrap">
        <LocationPicker />
        <NotificationBell />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ...state
  };
}

// Icons by nav id, reused by the Catalogue overview rows.
export const tabIcons = {
  services: <ServicesIcon />, products: <ProductsIcon />, 'vouchers-v2': <VouchersIcon />, stocktake: <StockTakeIcon />,
  'stock-transfers': <TransfersIcon />, resources: <ResourcesIcon />, forms: <FormsIcon />, taxes: <TaxesIcon />,
};

export default withRouter(connect(mapStateToProps)(CatalogueTopNav));
